import React from 'react';

interface DialogContentProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * DialogContent component for use with Dialog
 */
const DialogContent: React.FC<DialogContentProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`px-6 py-4 ${className}`}>
      {children}
    </div>
  );
};

export default DialogContent;